import React from "react";
import { connect } from "react-redux";
import Navbar from "../NavBar/Navbar";
import "./Header.css";
import overlay from "../../images/IMG_4003.PNG";

const Header = (props) => {
  return (
    <>
      <Navbar />
      <div className="wrapper">
        <div className="introduction">
          <div className="introBox">
            <h4 className="hfour">HELLO 👋 I'M</h4>
            <h1 className="hone">Faruk Suljagic</h1>
            <h4 className="hfour">Front-end Developer</h4>
            <p className="intro">
              I am a Junior Front-end Developer, with skills in
              <strong> HTML, CSS, JS, Reactjs</strong> (hooks, redux),{" "}
              <strong>Firebase</strong>.
            </p>
          </div>
        </div>
        <div className="overlay">
          <div className="information" />
          <h2 className="Front">Front-end Developer</h2>
          <div className="overlayImg" width="100px">
            <img className="imageoOverlay" src={overlay} alt="" />
          </div>
        </div>
      </div>
      <div
        className={props.toggleMenu === false ? "brgMenuClosed" : "brgMenuOpen"}
      >
        <a
          href="/about"
          className={props.toggleMenu === false ? "aboutbtnClosed" : "aboutbtn"}
        >
          About
        </a>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    toggleMenu: state.menu.burgerMenu,
  };
};

export default connect(mapStateToProps, null)(Header);
